export enum eExternalOrderStatus {
  new = 'new',
  initial_docs_available = 'initial_docs_available',
  title_report_available = 'title_report_available',
  signing_scheduled = 'signing_scheduled',
  signing_confirmed = 'signing_confirmed',
  signing_occurred = 'signing_occurred',
  waiting_for_funds = 'waiting_for_funds',
  funded = 'funded',
  recorded = 'recorded',
  funded_and_recorded = 'funded_and_recorded',
  policy_issued = 'policy_issued',
  cancelled = 'cancelled',
  clear_to_close = 'clear_to_close',
}

export const prettyExternalOrderStatus: Record<eExternalOrderStatus, string> = {
  cancelled: 'Cancelled',
  signing_confirmed: 'Signing Confirmed',
  signing_occurred: 'Signing Occurred',
  signing_scheduled: 'Signing Scheduled',
  funded: 'Funded',
  funded_and_recorded: 'Funded & Recorded',
  initial_docs_available: 'Initial Docs Available',
  new: 'New',
  policy_issued: 'Policy Issued',
  recorded: 'Recorded',
  title_report_available: 'Title Report Available',
  waiting_for_funds: 'Waiting for funds',
  clear_to_close: 'Clear to Close',
};
